import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'url'
})
export class UrlPipe implements PipeTransform {

  transform(value: string): any {
    if (!value) {
      return;
    }

    value = this.removeTrailingSlash(value);
    value = this.removeHttpPrefix(value);

    return value;
  }

  private removeTrailingSlash(value: string): string {
    if (value.charAt(value.length - 1) === '/') {
      return value.slice(0, value.length - 1);
    }

    return value;
  }

  removeHttpPrefix(value: string): string {
    return value
      .replace(new RegExp('http://', 'g'), '')
      .replace(new RegExp('https://', 'g'), '');
  }
}
